import { css } from '@emotion/core';
import { media, variables } from '@domain-group/fe-brary';

// eslint-disable-next-line import/prefer-default-export
export const container = css``;

export const sectionContainer = css`
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 48px;
  font-size: 14px;
  line-height: 24px;
  color: ${variables.colour.neutral700};
`;

export const sectionHeader = css`
  font-weight: 700;
  font-size: 25px;
  line-height: 30px;
  ${media('>=desktop')} {
    font-size: 39px;
    line-height: 48px;
  }
`;
